import { Outlet, generatePath } from 'react-router-dom';
import ChartGroupsColumn from '../../../components/charts/column/column-groups';
import useGroupsList from './hooks/use-list';

import ROUTES from '../../../routes';

import cn from '../styles.module.css';

const ChartGroups = (): React.JSX.Element => {
  const {
    categories,
    isLoading,
    isFetching,
    groups,
    categoryId,
    primaryAccountId,
    groupId,
  } = useGroupsList();

  return (
    <>
      <div className={cn.columnWrapper}>
        <ChartGroupsColumn
          groups={groups}
          categoryId={categoryId}
          primaryAccountId={primaryAccountId}
          currentCategory={categories.find((item) => item.id === categoryId)}
          isLoading={isLoading || isFetching}
          path={generatePath(ROUTES.GROUP_ADD, {
            categoryId: categoryId || 'categoryId',
            groupId: groupId || 'groupId',
            primaryAccountId: primaryAccountId || 'primaryAccountId',
          })}
        />
      </div>
      <Outlet />
    </>
  );
};

export default ChartGroups;
